import { render, staticRenderFns } from "./ListagemCoSeller.vue?vue&type=template&id=037d7cbb&scoped=true"
import script from "./ListagemCoSeller.vue?vue&type=script&lang=js"
export * from "./ListagemCoSeller.vue?vue&type=script&lang=js"
import style0 from "./ListagemCoSeller.vue?vue&type=style&index=0&id=037d7cbb&prod&scoped=true&lang=css"
import style1 from "./ListagemCoSeller.vue?vue&type=style&index=1&id=037d7cbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d7cbb",
  null
  
)

export default component.exports